var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6964 0L17.0164 2.376C11.3844 6.16 8.83244 10.208 8.83244 14.344C8.83244 18.04 11.2084 20.416 15.8724 21.56C16.1364 25.872 12.8804 29.656 8.21644 29.656C3.90444 29.656 0.648438 26.84 0.648438 21.296C0.648438 13.904 5.92844 5.896 15.6964 0ZM36.0244 0L37.3444 2.376C31.7124 6.16 29.1604 10.208 29.1604 14.344C29.1604 18.04 31.5364 20.416 36.2004 21.56C36.4644 25.872 33.2084 29.656 28.5444 29.656C24.2324 29.656 20.9764 26.84 20.9764 21.296C20.9764 13.904 26.2564 5.896 36.0244 0Z","fill":"currentColor"}));
}

Quote.defaultProps = {"width":"38","height":"30","viewBox":"0 0 38 30","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
